import React from "react";
import TitlePage from "../../../../app/Title/TitlePage/TitlePageView";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import Divider from "@material-ui/core/Divider";
import NumberFormat from "react-number-format";
import {numberWithCommaDataTableTemplate, priceDataTableTemplate} from "../../../../utils/formatters/Numbers";
import SubtitleLabel from "../../../../app/Title/SubtitleLabel/SubtitleLabelView";
import {InputText} from "primereact/inputtext";

const InsertExtensionAdmin = ({...props}) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                {props.messagesGrowl}
                <Grid container spacing={1}>
                    <Grid item xs={8}>
                        <TitlePage title="Operación \ Prórrogas Administrativas \ Insertar Prórroga"/>
                    </Grid>
                    <Grid item xs={4}>
                        <div style={{textAlign: 'right'}}>
                            <Button
                                label="Cancelar"
                                className="p-button-secondary"
                                onClick={props.handleReturnButton}/>&nbsp;
                            <Button
                                label="Guardar"
                                onClick={props.insertExtensionAdmin}/>
                        </div>
                    </Grid>
                    <Grid item xs={12}> <Divider/> </Grid>
                    <Grid item xs={12}>
                        <SubtitleLabel header="Préstamo" isBold={true}/>
                        <DataTable
                            value={props.loan}
                            selectionMode="single"
                            resizableColumns={true}
                            columnResizeMode={"fit"}>
                            <Column
                                field="emisora"
                                header="Emisora"
                                style={{textAlign: 'left'}}
                                sortable={true}/>
                            <Column
                                field="cantPrestamo"
                                header="Títulos"
                                style={{textAlign: 'right'}}
                                body={numberWithCommaDataTableTemplate}
                                sortable={true}/>
                            <Column
                                field="precio"
                                header="Precio"
                                style={{textAlign: 'right'}}
                                body={priceDataTableTemplate}
                                sortable={true}/>
                        </DataTable>
                        <Grid item xs={12}>
                            <SubtitleLabel header="Garantías" isBold={true}/>
                            <DataTable
                                value={props.guarantee}
                                selectionMode="single"
                                resizableColumns={true}
                                columnResizeMode={"fit"}>
                                <Column
                                    field="emisora"
                                    header="Emisora"
                                    style={{textAlign: 'left'}}
                                    sortable={true}/>
                                <Column
                                    field="titulos"
                                    header="Títulos"
                                    style={{textAlign: 'right'}}
                                    body={numberWithCommaDataTableTemplate}
                                    sortable={true}/>
                                <Column
                                    field="precioMercado"
                                    header="Precio"
                                    style={{textAlign: 'right'}}
                                    body={priceDataTableTemplate}
                                    sortable={true}/>
                            </DataTable>
                        </Grid>
                        <Grid item xs={12}>
                            <div className="p-grid">
                                <div className="p-col-4">
                                    <SubtitleLabel header="Plazo" isBold={true}/>
                                    <NumberFormat name="maturity"
                                                  value={props.maturity}
                                                  thousandSeparator={true}
                                                  onChange={props.saveDataExtensionAdmin}
                                                  allowNegative={false}
                                                  decimalScale={0}
                                                  maxLength={5}
                                                  customInput={InputText}/>
                                </div>
                                <div className="p-col-4">
                                    <SubtitleLabel header="Tasa" isBold={true}/>
                                    <NumberFormat customInput={InputText}
                                                  name="rate"
                                                  value={props.rate}
                                                  thousandSeparator={true}
                                                  decimalScale={2}
                                                  maxLength={8}
                                                  allowNegative={false}
                                                  onChange={props.saveDataExtensionAdmin}/>
                                </div>
                                <div className="p-col-4">
                                    <SubtitleLabel header="Sobretasa" isBold={true}/>
                                    <NumberFormat customInput={InputText}
                                                  name="surcharge"
                                                  value={props.surcharge}
                                                  thousandSeparator={true}
                                                  decimalScale={2}
                                                  maxLength={8}
                                                  allowNegative={false}
                                                  onChange={props.saveDataExtensionAdmin}/>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default InsertExtensionAdmin;